import React, { Component } from 'react';

class Birthday extends Component{

    state = {
        day : '0',
        month: '0',
        year: '0',
        isValidDate : false,
        birthdayDate : ''
    }

    static getDerivedStateFromProps(nextProps, prevState)
    {
      //if we have an init date for the edit profile page
      if(nextProps.birthdayDate !== null && nextProps.birthdayDate !== 'Invalid Date' && prevState.year === '0')
      {
        const dateArray = nextProps.birthdayDate.split('/');
        return ({day: dateArray[0], month: dateArray[1], year: dateArray[2], isValidDate: true, birthdayDate: nextProps.birthdayDate})
      }

      return null;
    }

    selectChangeHandler = (event) => {
        
        if(event.target && parseInt(event.target.value, 10)>=0){
            let numericValue = (parseInt(event.target.value, 10)<10 && parseInt(event.target.value, 10)>0)?0+event.target.value:parseInt(event.target.value, 10);
            if(numericValue===0){
                numericValue = '';
            }
 
            if(event.target.name==="day"){
                
                this.setState({ day : numericValue} );   
            }
            else if(event.target.name==="month"){
                this.setState({ month : numericValue});  
            }
            else if(event.target.name==="year"){
                this.setState({ year : numericValue});  
            }

            // trigger change event

            // EBE trick, because this part of code is done on select's onchange, and it takes time to reflect the setState, the following method
            // updateCurrentBirthday() already update the date with the current value, it prevents from doing this call once again for nothing
            //
            // Probably can be done with componentWillReceiveProps() but I did not have any nextPros here
            
            let currentUpdatedBirthday = this.updateCurrentBirthday(numericValue, event.target.name);
            if(this.isValidDateFormat(currentUpdatedBirthday)){
                
                this.triggerOnChangeEvent(currentUpdatedBirthday);
                this.setState({isValidDate:true, birthdayDate:currentUpdatedBirthday});
            
            }else{
                if(this.state.isValidDate){
                    // force to trigger an event to invalidate the form 
                    this.triggerOnChangeEvent('');
                }

                this.setState({isValidDate:false, birthdayDate:''});
            }
        }
    
    }

    updateCurrentBirthday = (currentVal, field) => {
        let birthdayDate = this.state.day + '/' + this.state.month + '/' + this.state.year;
        if(currentVal==='' || parseInt(currentVal, 10)>0){ 
            if( field==='day'){
                birthdayDate = currentVal + '/' + this.state.month + '/' + this.state.year;
            }else if(field==='month'){
                birthdayDate = this.state.day + '/' + currentVal + '/' + this.state.year; 
            }else if (field==='year'){
                birthdayDate = this.state.day + '/' + this.state.month + '/' + currentVal;  
            }
        }

        return birthdayDate;
    }

    triggerOnChangeEvent = (val) => {
        const fakeEventDom = { target : { value : val } };
        this.props.onChange(fakeEventDom, 'birthday');
        //console.log('trigger on change event : ', currentUpdatedBirthday);
    }

    isValidDateFormat = (shortDateFormat) => {

        let isValid = false;
        let dateParts = shortDateFormat.split('/');
        if(dateParts.length===3 && (dateParts[0].length>0 && dateParts[1].length>0 && dateParts[2].length>0)){
            
            let englishDateFormat = dateParts[2]+'/'+dateParts[1]+'/'+dateParts[0];
            let timestamp = Date.parse(englishDateFormat);
            isValid = !isNaN(timestamp);
        }
        return isValid;
    }

    render(){
        const currentTime = new Date();

        let daysArray = [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31]; 
        let monthsObj = [ {id:0, label:''}, {id:1, label:'Janvier'}, {id:2, label:'Février'}, {id:3, label:'Mars'}, {id:4, label:'Avril'}, {id:5, label:'Mai'}, {id:6, label:'Juin'}, 
            {id:7, label:'Juillet'}, {id:8, label:'Août'}, {id:9, label:'Septembre'}, {id:10, label:'Octobre'}, {id:11, label:'Novembre'}, {id:12, label:'Décembre'} 
        ]
        
        let yearsArray = [];
        yearsArray[0] = '';
        for(let i=0; i<14; i++ ){
            let startYear = currentTime.getFullYear() - 18 + i;   
            yearsArray[i+1] = startYear;
        }

        return (
            <div className="birthday-component">
                <select name="day" className="day" onChange={(e) => { this.selectChangeHandler(e)} } value={this.state.day===0?'':parseInt(this.state.day, 10)}> 
                { 
                    daysArray.map((day, index) => (
                        <option key={index} value={day} >
                            { day===0?'':day}
                        </option>
                    ))
                }
                </select>
                <select name="month" className="month" onChange={(e) => { this.selectChangeHandler(e)}} value={parseInt(this.state.month,10)}> 
                { 
                    monthsObj.map((monthInfo, index) => (
                        <option key={index} value={monthInfo.id}>
                            { monthInfo.label}
                        </option>
                    ))
                }
                </select>
                <select name="year" className="year" onChange={(e) => { this.selectChangeHandler(e)} } value={this.state.year===0?'':parseInt(this.state.year, 10)}>
                { 
                    yearsArray.map((year, index) => (
                        <option key={index} value={year===''?0:year}>
                            {year}
                        </option>
                    ))
                }
                </select>

                <input
                    name="birthday"
                    type="hidden"
                    className={this.props.classes.join(' ')}
                    defaultValue={(this.state.isValidDate && this.state.birthdayDate!=='')?this.state.birthdayDate:''}
                    onChange = {this.props.onChange}
                />
            </div>
           
        );
    }   

}

export default Birthday;


// WEBPACK FOOTER //
// ./src/components/Birthday/Birthday.js